import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/client/lib/api-client'

export interface AiOverviewSummary {
  total: number
  with_aio: number
  mentioned: number
}

export interface AiOverviewTrend {
  week_key: string
  week_start: string
  total_checked: number
  with_aio: number
  mentioned: number
}

export interface AiOverviewKeyword {
  keyword: string
  search_volume: number | null
  position: number | null
  ai_overview_exists: number
  ai_overview_present: number
  checked_at: string
}

export interface AiOverviewData {
  summary: AiOverviewSummary
  trend: AiOverviewTrend[]
  keywords: AiOverviewKeyword[]
}

export function useAiOverview(siteId: string) {
  return useQuery({
    queryKey: ['sites', siteId, 'ai-overview'],
    queryFn: () => apiClient.get<AiOverviewData>(`/api/sites/${siteId}/ai-overview`),
    enabled: !!siteId,
    staleTime: 15 * 60 * 1000, // 15 min (server caches 30min)
  })
}
